import React from "react";
import Icon from "../icon";
import Img from "gatsby-image";
var ImageWithIcon = function ImageWithIcon(_ref) {
    var image = _ref.image, _onClick = _ref.onClick, icon = _ref.icon;
    if (image.fluid.width < 650) {
        return /*#__PURE__*/ React.createElement(Img, {
            fluid: image.fluid,
            style: {
                maxWidth: image.fluid.width
            },
            className: "mx-auto"
        });
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "absolute top-0 right-0 pt-3 pr-3 hover:bg-gray-300",
        onClick: function onClick() {
            return _onClick(image);
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: icon,
        color: "#c2bfc5",
        className: "w-5 relative cursor-pointer",
        tooltip: "Bild vergr\xF6\xDFern"
    })), /*#__PURE__*/ React.createElement("div", {
        onClick: function onClick() {
            return _onClick(image);
        },
        className: "cursor-pointer"
    }, /*#__PURE__*/ React.createElement(Img, {
        fluid: image.fluid,
        style: {
            maxWidth: image.fluid.width
        },
        className: "mx-auto"
    })));
};
export default ImageWithIcon;
